import {
  BOARD_WIDTH,
  LANE_HEIGHT,
  ROW_PADDING_Y,
  TECHNICIAN_COL_WIDTH,
} from '../../../shared/lib/schedule';
import { BOARD_LAYER } from '../model/boardLayers';

const SKELETON_ROWS = 6;

/** Placeholder rows while the schedule query is in flight — one per expected technician. */
export const BoardSkeleton = () => (
  <div className="animate-pulse">
    {Array.from({ length: SKELETON_ROWS }, (_, i) => (
      <div
        key={i}
        className="flex border-b border-slate-200"
        style={{ height: LANE_HEIGHT + ROW_PADDING_Y * 2 }}
      >
        <div
          className={`sticky left-0 flex shrink-0 items-center gap-3.5 bg-white p-3 outline outline-1 outline-offset-[-0.50px] outline-slate-200 ${BOARD_LAYER.technicianColumn}`}
          style={{ width: TECHNICIAN_COL_WIDTH }}
        >
          <div className="h-11 w-11 shrink-0 rounded-full bg-gray-200" />
          <div className="flex-1 space-y-2">
            <div className="h-3 w-28 rounded bg-gray-200" />
            <div className="h-3 w-20 rounded bg-gray-100" />
          </div>
        </div>
        <div className="shrink-0" style={{ width: BOARD_WIDTH }} />
      </div>
    ))}
  </div>
);
